import { useCallback } from "react";

import { apiClient } from "../../lib/api";
import { getUserPreferences } from "../../lib/user-preferences";

import type { ApiPayload } from "common/classes/api-payload";

export function useLogin(): (email: string, password: string, turnstileToken?: string) => Promise<ApiPayload> {
  const login = useCallback(async (email: string, password: string, turnstileToken?: string): Promise<ApiPayload> => {
    const response = await apiClient.login(email, password, turnstileToken);

    if (!response.success) {
      const error = new Error(response.message ?? `unexpectedError`) as Error & {
        details?: Record<string, unknown>;
      };

      error.details = response.details;

      throw error;
    }

    await apiClient.updatePreferences(getUserPreferences());

    return response;
  }, []);

  return login;
}
